import {
  Component,
  OnDestroy,
  OnInit, ViewChild
} from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import {GridSetting, GridSettings, GridState, User} from '../../../shared';
import { ExtraFilteringOptions, LoadOptions } from '../../../shared/models/shared.model';
import { Subject } from 'rxjs';
import { UserApi } from '../../../api';
import { FilterBuilderService } from '../../../service/filter-builder.service';
import { LoaderService } from '../../../core/loader/loader.service';
import { CountrySubdivisionDataService } from '../../../api/country-subdivision-data.service';
import CustomStore from 'devextreme/data/custom_store';
import {map, take, takeUntil} from 'rxjs/operators';
import {CountryMappingOption} from '../../../shared/models/country-subdivision-data.model';
import {MappingAction, MappingMode} from '../../../shared/enum/mapping-mode.enum';

@Component({
  selector: 'app-country-subdivision-mapping',
  templateUrl: 'country-subdivision-mapping.component.html'
})

export class CountrySubdivisionMappingComponent implements OnInit, OnDestroy {
  @ViewChild('countrySubdivisionMappingDataGrid') countrySubdivisionMappingDataGrid: DxDataGridComponent;
  @ViewChild('countrySubdivisionMasterDataGrid') countrySubdivisionMasterDataGrid: DxDataGridComponent;

  public countrySubdivisionMappingDataSource = {};
  public countrySubdivisionMappingSelectedRowMap: any;
  public countrySubdivisionMasterDataSource = {};
  public countrySubdivisionMasterSelectedRowMap: any;

  public extraFilteringOptions: ExtraFilteringOptions[] = [
	{ column: 'Active', value: false },
  ];
  public currentUser: User;
  public searchText;

  // Mapping grid header
  public sourceCountrySubdivisionHeaderDataSource;
  public sourceCountryHeaderDataSource;
  public dataProviderCodeHeaderDataSource;
  // DataProviderPrimaryOrDefaultCountryGeographicalEntityShortName
  public countryGeographicalEntityShortNameHeaderDataSource;
  // DataProviderPrimaryOrDefaultCountryGeographicalEntityCountryAlpha2Code
  public countryGeographicalEntityCountryAlpha2CodeHeaderDataSource;
  // IsDataProviderPrimaryOrDefaultCountryInconsistentMappingMessage
  public countryInconsistentMappingMessageHeaderDataSource;
  public countryMappingModeNameHeaderDataSource;
  // CountryShortName
  public mappingCountryShortNameHeaderDataSource;
  public mappingCountryAlpha2CodeHeaderDataSource;
  public countryAlpha2CodeMismatchErrorHeaderDataSource;
  // CountrySubdivisionShortName;
  public mappingCountrySubdivisionShortNameHeaderDataSource;
  // CountrySubdivisionTypeName
  public mappingCountrySubdivisionTypeNameHeaderDataSource;
  // CountrySubdivisionCountryAlpha2Code
  public mappingCountrySubdivisionCountryAlpha2CodeHeaderDataSource;
  // CountrySubdivisionCode
  public mappingCountrySubdivisionCodeHeaderDataSource;
  // CountrySubdivisionParentCode
  public mappingCountrySubdivisionParentCodeHeaderDataSource;
  // CountrySubdivisionParentShortName
  public mappingCountrySubdivisionParentShortNameHeaderDataSource;
  // CountrySubdivisionParentTypeName
  public mappingCountrySubdivisionParentTypeNameHeaderDataSource;
  // CreatedByUserFullNameSortableOrPrincipalName
  public mappingCreatedByUserFullNameSortableOrPrincipalNameHeaderDataSource;
  // CreatedOn
  public mappingCreatedOnHeaderDataSource;
  // ModifiedByUserFullNameSortableOrPrincipalName
  public mappingModifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource;
  // ModifiedOn
  public mappingModifiedOnHeaderDataSource;
  // ReviewedByUserFullNameSortableOrPrincipalName
  public mappingReviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource;
  // ReviewedOn
  public mappingReviewedOnHeaderDataSource;
  public mappingMappingModeName: any;

  // Master grid header
  public countryShortNameHeaderDataSource;
  public countryAlpha2CodeHeaderDataSource;
  public countryAlpha3CodeHeaderDataSource;
  public reportRegionListHeaderDataSource;
  public countrySubdivisionShortNameHeaderDataSource;
  public countrySubdivisionTypeNameHeaderDataSource;
  public countrySubdivisionCodeHeaderDataSource;
  public countrySubdivisionParentCodeHeaderDataSource;
  public countrySubdivisionParentShortNameHeaderDataSource;
  public countrySubdivisionParentTypeNameHeaderDataSource;
  public createdByUserFullNameSortableOrPrincipalNameHeaderDataSource;
  public modifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource;
  public reviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource;
  public createdOnHeaderDataSource;
  public modifiedOnHeaderDataSource;
  public reviewedOnHeaderDataSource;

  private _destroyed$ = new Subject();
  private isCountrySubdivisionMappingDataLoading: boolean;
  private mappingDataGridCurrentPage: number;
  private isCountrySubdivisionMasterDataLoading: boolean;
  private masterDataGridCurrentPage: number;

  public isLoadCountrySubdivisionMappingGridDataSource: boolean;
  public isLoadCountrySubdivisionMasterGridDataSource: boolean;
  private readonly mappingGridName: string = 'countrySubdivisionMappingDataGrid';
  private readonly masterGridName: string = 'countrySubdivisionMasterDataGrid';
  private readonly pageName: string = 'countrySubdivisionMapping';
  private currentCountrySubdivisionMappingDataGridState: GridState;
  private currentCountrySubdivisionMasterDataGridState: GridState;
  private countrySubdivisionMappingDataGridSettings: GridSettings;
  private countrySubdivisionMasterDataGridSettings: GridSettings;
  private isCountrySubdivisionMappingDataGridSettingLoading = true;
  private isCountrySubdivisionMasterDataGridSettingLoading = true;
  private countrySubdivisionMappingDataGridSetting: GridSetting = new GridSetting();
  private countrySubdivisionMasterDataGridSetting: GridSetting = new GridSetting();

  constructor(
	private countrySubdivisionService: CountrySubdivisionDataService,
	private userService: UserApi,
	private filterBuilder: FilterBuilderService,
	private loaderService: LoaderService,
  ) {
  }

  ngOnInit() {
	this.loaderService.show();
	this.currentUser = this.userService.logonUser;
	if (!this.currentUser) {
		return;
	}
	this.countrySubdivisionMappingDataGridSettings = {
		PageName: this.pageName,
		GridName: this.mappingGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridSettings(this.countrySubdivisionMappingDataGridSettings)
		.pipe(take(1))
		.subscribe((settings) => {
		if (settings && settings.Settings) {
			if (typeof settings.Settings === 'string') {
			this.countrySubdivisionMappingDataGridSetting = JSON.parse(settings.Settings);
			} else {
			this.countrySubdivisionMappingDataGridSetting = settings.Settings;
			}
		} else {
			this.countrySubdivisionMappingDataGridSetting.autosave = true;
			this.countrySubdivisionMappingDataGridSettings.Settings = JSON.stringify({autosave: true});
			this.updateGridSettings(this.countrySubdivisionMappingDataGridSettings);
		}
		this.loadCountrySubdivisionMappingDataGridState();
		});

	this.countrySubdivisionMasterDataGridSettings = {
		PageName: this.pageName,
		GridName: this.masterGridName,
		OwnedByUserId: this.currentUser.UserId
	};

	this.userService.getGridSettings(this.countrySubdivisionMasterDataGridSettings)
		.pipe(take(1))
		.subscribe((settings) => {
		if (settings && settings.Settings) {
			if (typeof settings.Settings === 'string') {
			this.countrySubdivisionMasterDataGridSetting = JSON.parse(settings.Settings);
			} else {
			this.countrySubdivisionMasterDataGridSetting = settings.Settings;
			}
		} else {
			this.countrySubdivisionMasterDataGridSetting.autosave = true;
			this.countrySubdivisionMasterDataGridSettings.Settings = JSON.stringify({autosave: true});
			this.updateGridSettings(this.countrySubdivisionMasterDataGridSettings);
		}
		this.loadCountrySubdivisionMasterDataGridState();
		});
	this.setMappingDataGridHeaderDataSource();
  }

  private loadCountrySubdivisionMappingDataSource() {
	this.isCountrySubdivisionMappingDataGridSettingLoading = false;
	this.countrySubdivisionMappingDataSource = new CustomStore({
		key: 'CountrySubdivisionMappingId',
		load: (loadOptions: any) => {
		this.isCountrySubdivisionMappingDataLoading = true;
		this.loaderService.show();
		const filter = this.formatFilterOperators(loadOptions.filter);
		const finalOptions: LoadOptions = loadOptions;
		finalOptions.filter = filter;
		finalOptions.extraParams = this.extraFilteringOptions;

		return this.countrySubdivisionService.getCountrySubdivisionMappingGrid(finalOptions)
			.toPromise()
			.then((data: any) => {
			this.isCountrySubdivisionMappingDataLoading = false;
			this.loaderHandler();
			return {
				data: data.data,
				totalCount: data.totalCount,
				summary: data.summary,
				groupCount: data.groupCount
			};
			})
			.catch(error => {
			this.isCountrySubdivisionMappingDataLoading = false;
			this.loaderHandler();
			throw new Error('Data Loading Error');
			});
		}
	});
	this.isLoadCountrySubdivisionMappingGridDataSource = true;
  }

  private loadCountrySubdivisionMappingDataGridState() {
	const countrySubdivisionMappingDataGridState: GridState = {
		PageName: this.pageName,
		GridName: this.mappingGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridState(countrySubdivisionMappingDataGridState)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((state) => {
		if (state) {
			this.currentCountrySubdivisionMappingDataGridState = state;
		} else {
			this.currentCountrySubdivisionMappingDataGridState = {
			PageName: this.pageName,
			GridName: this.mappingGridName,
			OwnedByUserId: this.currentUser.UserId,
			State: null
			};
		}
		this.loadCountrySubdivisionMappingDataSource();
		});
  }

  public loadMappingState = () => {
	return this.currentCountrySubdivisionMappingDataGridState.State ? JSON.parse(this.currentCountrySubdivisionMappingDataGridState.State) : null;
  }

  public saveMappingState = (state) => {
	if (this.countrySubdivisionMappingDataGridSetting) {
		let gridSetting: GridSetting;
		if (typeof this.countrySubdivisionMappingDataGridSetting === 'string') {
		gridSetting = JSON.parse(this.countrySubdivisionMappingDataGridSetting);
		} else {
		gridSetting = this.countrySubdivisionMappingDataGridSetting;
		}
		if (gridSetting.autosave) {
		this.currentCountrySubdivisionMappingDataGridState.State = JSON.stringify(state);
		this.updateGridState(this.currentCountrySubdivisionMappingDataGridState);
		}
	}
  }

  private loadCountrySubdivisionMasterDataSource() {
	this.isCountrySubdivisionMasterDataGridSettingLoading = false;
	this.countrySubdivisionMasterDataSource = new CustomStore({
		key: 'CountrySubdivisionGeographicalEntityId',
		load: (loadOptions: any) => {
		this.isCountrySubdivisionMasterDataLoading = true;
		this.loaderService.show();
		const filter = this.formatFilterOperators(loadOptions.filter);
		const finalOptions: LoadOptions = loadOptions;
		finalOptions.filter = filter;
		finalOptions.extraParams = this.extraFilteringOptions;

		return this.countrySubdivisionService.getCountrySubdivisionMasterWithReportRegionListGrid(finalOptions)
			.toPromise()
			.then((data: any) => {
			this.isCountrySubdivisionMasterDataLoading = false;
			this.loaderHandler();
			return {
				data: data.data,
				totalCount: data.totalCount,
				summary: data.summary,
				groupCount: data.groupCount
			};
			})
			.catch(error => {
			this.isCountrySubdivisionMasterDataLoading = false;
			this.loaderHandler();
			throw new Error('Data Loading Error');
			});
		}
	});
	this.setMasterDataGridHeaderDataSource();
	this.isLoadCountrySubdivisionMasterGridDataSource = true;
  }

  private loadCountrySubdivisionMasterDataGridState() {
	const countrySubdivisionMasterDataGridState: GridState = {
		PageName: this.pageName,
		GridName: this.masterGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridState(countrySubdivisionMasterDataGridState)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((state) => {
		if (state) {
			this.currentCountrySubdivisionMasterDataGridState = state;
		} else {
			this.currentCountrySubdivisionMasterDataGridState = {
			PageName: this.pageName,
			GridName: this.masterGridName,
			OwnedByUserId: this.currentUser.UserId,
			State: null
			};
		}
		this.loadCountrySubdivisionMasterDataSource();
		});
  }

  public loadMasterState = () => {
	return this.currentCountrySubdivisionMasterDataGridState.State ? JSON.parse(this.currentCountrySubdivisionMasterDataGridState.State) : null;
  }

  public saveMasterState = (state) => {
	if (this.countrySubdivisionMasterDataGridSetting) {
		let gridSetting: GridSetting;
		if (typeof this.countrySubdivisionMasterDataGridSetting === 'string') {
		gridSetting = JSON.parse(this.countrySubdivisionMasterDataGridSetting);
		} else {
		gridSetting = this.countrySubdivisionMasterDataGridSetting;
		}
		if (gridSetting.autosave) {
		this.currentCountrySubdivisionMasterDataGridState.State = JSON.stringify(state);
		this.updateGridState(this.currentCountrySubdivisionMasterDataGridState);
		}
	}
  }

  private updateGridSettings(gridSettings: GridSettings) {
	gridSettings.SavedOn = new Date();
	this.userService.setGridSettings(gridSettings).pipe(take(1)).subscribe();
  }

  private updateGridState(gridState: GridState) {
	gridState.SavedOn = new Date();
	this.userService.setGridState(gridState).pipe(take(1)).subscribe();
  }

  private setMappingDataGridHeaderDataSource() {
	this.sourceCountrySubdivisionHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SourceCountrySubdivision';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
	this.sourceCountryHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SourceCountry';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
	this.dataProviderCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'DataProviderCode';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
		// DataProviderPrimaryOrDefaultCountryGeographicalEntityShortName
	this.countryGeographicalEntityShortNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'DataProviderPrimaryOrDefaultCountryGeographicalEntityShortName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
		// DataProviderPrimaryOrDefaultCountryGeographicalEntityCountryAlpha2Code
	this.countryGeographicalEntityCountryAlpha2CodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'DataProviderPrimaryOrDefaultCountryGeographicalEntityCountryAlpha2Code';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
		// IsDataProviderPrimaryOrDefaultCountryInconsistentMappingMessage
	this.countryInconsistentMappingMessageHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'IsDataProviderPrimaryOrDefaultCountryInconsistentMappingMessage';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});

	this.countryMappingModeNameHeaderDataSource = [
		{
		text: 'New',
		value: 0
		},
		{
		text: 'Map',
		value: 1
		},
		{
		text: 'Save',
		value: 2
		},
		{
		text: 'Omit',
		value: 2
		}
	];

	this.mappingMappingModeName = [
		{
		text: 'New',
		value: 0
		},
		{
		text: 'Map',
		value: 1
		},
		{
		text: 'Save',
		value: 2
		},
		{
		text: 'Omit',
		value: 2
		}
	];
		// CountryShortName
	this.mappingCountryShortNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryShortName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
	this.mappingCountryAlpha2CodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryAlpha2Code';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
	this.countryAlpha2CodeMismatchErrorHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryAlpha2CodeMismatchError';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
		// CountrySubdivisionShortName;
	this.mappingCountrySubdivisionShortNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionShortName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
		// CountrySubdivisionTypeName
	this.mappingCountrySubdivisionTypeNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionTypeName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
		// CountrySubdivisionCountryAlpha2Code
	this.mappingCountrySubdivisionCountryAlpha2CodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionCountryAlpha2Code';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
		// CountrySubdivisionCode
	this.mappingCountrySubdivisionCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionCode';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
		// CountrySubdivisionParentCode
	this.mappingCountrySubdivisionParentCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionParentCode';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
		// CountrySubdivisionParentShortName
	this.mappingCountrySubdivisionParentShortNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionParentShortName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
		// CountrySubdivisionParentTypeName
	this.mappingCountrySubdivisionParentTypeNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionParentTypeName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
		// CreatedByUserFullNameSortableOrPrincipalName
	this.mappingCreatedByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
		// ModifiedByUserFullNameSortableOrPrincipalName
	this.mappingModifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
		// ReviewedByUserFullNameSortableOrPrincipalName
	this.mappingReviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});

	this.mappingCreatedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});

	this.mappingModifiedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});

	this.mappingReviewedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMapping(loadOptions);
		}
	});
  }

  private setMasterDataGridHeaderDataSource() {
	this.countryShortNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryShortName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});
	this.countryAlpha2CodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryAlpha2Code';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});
	this.countryAlpha3CodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryAlpha3Code';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});
	this.reportRegionListHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReportRegionList';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});
	this.countrySubdivisionShortNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionShortName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});
	this.countrySubdivisionTypeNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionTypeName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});
	this.countrySubdivisionCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionCode';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});
	this.countrySubdivisionParentCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionParentCode';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});
	this.countrySubdivisionParentShortNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionParentShortName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});
	this.countrySubdivisionParentTypeNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionParentTypeName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});
	this.createdByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});
	this.modifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});
	this.reviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});

	this.createdOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});

	this.modifiedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});

	this.reviewedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountrySubdivisionMaster(loadOptions);
		}
	});
  }

  public getHeaderFiltersCountrySubdivisionMapping(loadingOption) {
	return this.countrySubdivisionService.getHeaderFiltersCountrySubdivisionMappingGrid(loadingOption)
		.toPromise()
		.catch(error => { throw new Error('Data Loading Error'); });
  }

  public getHeaderFiltersCountrySubdivisionMaster(loadingOption) {
	return this.countrySubdivisionService.getHeaderFiltersCountrySubdivisionMasterWithReportRegionListGrid(loadingOption)
		.toPromise()
		.catch(error => { throw new Error('Data Loading Error'); });
  }

  private formatFilterOperators(rawFilter: any[]) {
	if (!rawFilter) {
		return null;
	}
	const filterData = this.filterBuilder.handleNotFilterFormatting(rawFilter);
	return this.filterBuilder.filterFormatting(filterData);
  }

  private loaderHandler() {
	if (
		!this.isCountrySubdivisionMasterDataLoading &&
		!this.isCountrySubdivisionMappingDataLoading &&
		!this.isCountrySubdivisionMappingDataGridSettingLoading &&
		!this.isCountrySubdivisionMasterDataGridSettingLoading) {
		this.loaderService.hide();
	}
  }

  ngOnDestroy() {
  }

  public selectionMappingDataChangedHandler() {
	if (this.countrySubdivisionMappingDataGrid.instance.getSelectedRowsData()[0]) {
		this.countrySubdivisionMappingSelectedRowMap = this.countrySubdivisionMappingDataGrid.instance.getSelectedRowsData()[0];
		this.countrySubdivisionMasterDataGrid.instance.columnOption('CountryShortName', 'filterValues', [
		this.countrySubdivisionMappingSelectedRowMap['DataProviderPrimaryOrDefaultCountryGeographicalEntityShortName']
		]);
		if (!this.countrySubdivisionMasterDataGrid.instance.getSelectedRowsData()[0]) {
		this.loadCountrySubdivisionMasterDataSource();
		} else {
		this.refreshCountrySubdivisionMasterDataGrid();
		}
	}
  }

  /**
   * Context menu for company mapping data grid
   * @param event
   */
  public mappingDataGridContextMenu(e) {
	if (e.target === 'content') {
		// e.items can be undefined
		if (!e.items) { e.items = []; }

		// Add a custom menu item
		e.items.push(
		{
			text: 'Refresh',
			icon: 'refresh',
			onItemClick: () => {
			this.refreshCountrySubdivisionMappingDataGrid();
			}
		},
		{
			text: 'Grid Settings',
			items: [
			{
				text: this.countrySubdivisionMappingDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
				onItemClick: () => {
				this.countrySubdivisionMappingDataGridSetting.autosave = !this.countrySubdivisionMappingDataGridSetting.autosave;
				this.countrySubdivisionMappingDataGridSettings.Settings = JSON.stringify(this.countrySubdivisionMappingDataGridSetting);
				this.updateGridSettings(this.countrySubdivisionMappingDataGridSettings);
				}
			}
			]
		}
		);
	}
  }

  public onReady(e) {
	const grid = e.component;
	const selection = grid.getSelectedRowKeys();
	if (this.countrySubdivisionMappingSelectedRowMap) {
		const currentDataItems = this.countrySubdivisionMappingDataGrid.instance.getDataSource().items();
		const isSelectedRowExists = currentDataItems.find(item =>
		item.CountrySubdivisionGeographicalEntityId ===
		this.countrySubdivisionMappingSelectedRowMap.CountrySubdivisionGeographicalEntityId
		);
		if (!isSelectedRowExists) {
		grid.selectRowsByIndexes([0]);
		}
	}
	if (selection.length === 0) {
		grid.selectRowsByIndexes([0]);
	}
  }

  public onReadyMasterGrid(e) {
	const grid = e.component;
	const selection = grid.getSelectedRowKeys();
	if (selection.length === 0) {
		grid.selectRowsByIndexes([0]);
	}
  }

  private refreshCountrySubdivisionMappingDataGrid() {
	this.mappingDataGridCurrentPage = this.countrySubdivisionMappingDataGrid.instance.pageIndex();
	this.countrySubdivisionMappingDataGrid.instance.refresh();
  }

  public selectionMasterDataChangedHandler() {
	if (this.countrySubdivisionMasterDataGrid.instance.getSelectedRowsData()[0]) {
		this.countrySubdivisionMasterSelectedRowMap = this.countrySubdivisionMasterDataGrid.instance.getSelectedRowsData()[0];
	}
  }

  public customizeCountrySubdivisionGeographicalEntityId(cellInfo) {
	const idStr = 'CnSdMp_000000';
	const cellValue = String(cellInfo.value);
	const index = idStr.length - cellValue.length;
	const finalText = idStr.slice(0, index) + cellValue;
	return finalText;
  }

  /**
   * Context menu for company master data grid
   * @param event
   */
  public masterDataGridContextMenu(e) {
	if (e.target === 'content') {
		// e.items can be undefined
		if (!e.items) { e.items = []; }

		// Add a custom menu item
		e.items.push(
		{
			text: 'Refresh',
			icon: 'refresh',
			onItemClick: () => {
			this.refreshCountrySubdivisionMasterDataGrid();
			}
		},
		{
			text: 'Grid Settings',
			items: [
			{
				text: this.countrySubdivisionMasterDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
				onItemClick: () => {
				this.countrySubdivisionMasterDataGridSetting.autosave = !this.countrySubdivisionMasterDataGridSetting.autosave;
				this.countrySubdivisionMasterDataGridSettings.Settings = JSON.stringify(this.countrySubdivisionMasterDataGridSetting);
				this.updateGridSettings(this.countrySubdivisionMasterDataGridSettings);
				}
			}
			]
		}
		);
	}
  }

  public customizeCountrySubdivisionMappingId(cellInfo) {
	const idStr = 'GE_000000';
	const cellValue = String(cellInfo.value);
	const index = idStr.length - cellValue.length;
	const finalText = idStr.slice(0, index) + cellValue;
	return finalText;
  }

  private refreshCountrySubdivisionMasterDataGrid() {
	this.masterDataGridCurrentPage = this.countrySubdivisionMasterDataGrid.instance.pageIndex();
	this.countrySubdivisionMasterDataGrid.instance.refresh();
  }

  public map(CountrySubdivisionGeographicalEntityId) {
	const mappingData: CountryMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.MappingModeId = MappingMode.Mapped;
	mappingData.ActionType = MappingAction.Map;
	mappingData.CountrySubdivisionMappingId = this.countrySubdivisionMappingSelectedRowMap.CountrySubdivisionMappingId;
	mappingData.CountrySubdivisionGeographicalEntityId = CountrySubdivisionGeographicalEntityId;
	this.loaderService.show();
	this.countrySubdivisionService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshCountrySubdivisionMappingDataGrid();
		});
  }

  public omit(CountrySubdivisionMappingId) {
	const mappingData: CountryMappingOption = {};
	mappingData.MappingModeId = MappingMode.Omitted;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Omit;
	mappingData.CountrySubdivisionMappingId = CountrySubdivisionMappingId;
	this.loaderService.show();
	this.countrySubdivisionService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshCountrySubdivisionMappingDataGrid();
		});
  }

  public save(CountrySubdivisionMappingId) {
	const mappingData: CountryMappingOption = {};
	mappingData.MappingModeId = MappingMode.Saved;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Save;
	mappingData.CountrySubdivisionMappingId = CountrySubdivisionMappingId;
	this.loaderService.show();
	this.countrySubdivisionService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshCountrySubdivisionMappingDataGrid();
		});
  }

  public accept(CountrySubdivisionMappingId) {
	const mappingData: CountryMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Accept;
	mappingData.CountrySubdivisionMappingId = CountrySubdivisionMappingId;
	this.loaderService.show();
	this.countrySubdivisionService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshCountrySubdivisionMappingDataGrid();
		});
  }

  public review(CountrySubdivisionMappingId) {
	const mappingData: CountryMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Review;
	mappingData.CountrySubdivisionMappingId = CountrySubdivisionMappingId;
	this.loaderService.show();
	this.countrySubdivisionService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshCountrySubdivisionMappingDataGrid();
		});
  }

  public deactivate(CountrySubdivisionMappingId) {
	const mappingData: CountryMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Deactivate;
	mappingData.CountrySubdivisionMappingId = CountrySubdivisionMappingId;
	this.loaderService.show();
	this.countrySubdivisionService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshCountrySubdivisionMappingDataGrid();
		});
  }

  public reactivate(CountrySubdivisionMappingId) {
	const mappingData: CountryMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Reactivate;
	mappingData.CountrySubdivisionMappingId = CountrySubdivisionMappingId;
	this.loaderService.show();
	this.countrySubdivisionService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshCountrySubdivisionMappingDataGrid();
		});
  }
}
